import React, { useState, useEffect, useCallback } from "react";
import Drawer from "@mui/joy/Drawer";
import Button from "@mui/joy/Button";
import Sheet from "@mui/joy/Sheet";
import Typography from "@mui/joy/Typography";
import comentIcon from "../../../assets/customerAssets/icons/comentIcon.svg";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getGoalComments } from "../../../action/goalCommentsAction";
import { toast } from "react-toastify";
import { CommentSection } from "react-comments-section";
import user_D from "../../../assets/customerAssets/user_D.jpeg";
import {
  addGoalComment,
  addClubGoalComment,
} from "../../../api/addGoalComment";
import { useNavigate } from "react-router-dom";
import CommentSkeleton from "./CommentSkeleton";
import { getNewComments } from "../../../api/getCommentsNew";
import "react-comments-section/dist/index.css";

export default function DrawerFilters({ count, id, api, allow }) {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = useSelector((state) => state.user);
  const [commentCount, setCommentCount] = useState(count);
  const loggedUser = useSelector((state) => state.loggedUser.user);
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);

  const fetchComments = useCallback(
    async (api) => {
      try {
        setLoading(true);
        const comments = await getNewComments(api, token);
        if (comments?.success) {
          const data = comments?.data?.map((ele) => ({
            userId: ele.user_id,
            comId: ele.id,
            text: ele.comment_text,
            avatarUrl: ele?.clubGoalCommentedUser?.profile_img || user_D,
            timestamp: ele.createdAt,
            fullName:
              ele?.clubGoalCommentedUser?.firstName +
              " " +
              ele?.clubGoalCommentedUser?.lastName,
            replies: [],
          }));
          setComments(data);
          // setComments(comments?.data?.count);
          setCommentCount(comments?.data?.count);
        }
      } catch (error) {
        toast.error(`Error while fetching comments ,${error.message}!`);
      } finally {
        setLoading(false);
      }
    },
    [token],
  );

  useEffect(() => {
    if (open) {
      fetchComments(api);
    }
  }, [open]);

  return (
    <React.Fragment>
      <Button
        className="icon-div"
        sx={[
          { padding: "0", backgroundColor: "transparent" },
          (theme) => ({
            "&:hover": {
              backgroundColor: "transparent",
            },
          }),
        ]}
        onClick={() => {
          if (allow) {
            setOpen(true);
          } else {
            toast.error(
              "Private Club!, Only club members can comment on the club.",
            );
          }
          // setOpen(true)
        }}
      >
        <img src={comentIcon} className="iconImg" />
      </Button>
      <Typography component="p" sx={{ color: "white" }}>
        {commentCount}
      </Typography>
      <Drawer
        size="md"
        variant="plain"
        open={open}
        anchor="bottom"
        onClose={() => setOpen(false)}
        slotProps={{
          content: {
            sx: {
              bgcolor: "transparent",
              p: { md: 3, sm: 0 },
              boxShadow: "none",
              width: { xs: "100%", sm: "50%", md: "50%", lg: "50%", xl: "50%" },
              right: "0",
            },
          },
        }}
      >
        <Sheet
          sx={{
            borderRadius: "md",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            height: "100%",
            width: "100%",
            overflow: "auto",
            alignSelf: "end",
            backgroundColor: "#242743",
          }}
          className="comment-box-wrapper"
        >
          {loading ? (
            <CommentSkeleton />
          ) : (
            <CommentSection
              currentUser={
                userData?.data?.is_skip
                  ? null
                  : {
                      currentUserId: userData?.data?.id,
                      currentUserImg: userData?.data?.profile_img || user_D,
                      currentUserProfile: "",
                      currentUserFullName:
                        userData?.data?.firstName +
                        " " +
                        userData?.data?.lastName,
                    }
              }
              commentsCount={commentCount}
              logIn={{
                onLogin: () => {
                  navigate("/login");
                },
                signUpLink: "https://mynetgoals.com/register",
              }}
              commentData={comments}
              placeholder="Write your comment..."
              onSubmitAction={async (data) => {
                try {
                  const resData = await addClubGoalComment(
                    userData?.data?.id,
                    id,
                    data.text,
                    token,
                  );
                  if (resData.success) {
                    toast.success(resData.message);
                  } else {
                  }
                } catch (error) {
                  toast.error(error.message);
                }
              }}
              onReplyAction={async (data) => {
                try {
                  const resData = await addClubGoalComment(
                    userData?.data?.id,
                    id,
                    data.text,
                    token,
                    data.repliedToCommentId,
                  );
                  if (resData.success) {
                    toast.success(resData.message);
                  } else {
                  }
                } catch (error) {
                  toast.error(error.message);
                }
              }}
              currentData={(data) => {
                // "";
                setCommentCount(data.length);
              }}
              onlogIn={{
                onLogin: () => navigate("/login"),
                signupLink: "https://mynetgoals.com/register",
              }}
            />
          )}
        </Sheet>
      </Drawer>
    </React.Fragment>
  );
}
